module.exports = __webpack_public_path__ + "static/scale-model-of-alabama-museum-of-natural-history-in-tuscaloosa-alabama-b28a84cc99533bab9cccfa4538cabded.png";